module.exports = __webpack_public_path__ + "img/role-25.baf30955.svg";